import { selectHelplyAccountId } from 'ducks/accounts/selectors/selectHelplyAccountId'
import { selectHasHelplyCopilotAddon } from 'ducks/accounts/selectors/selectHasHelplyCopilotAddon'

export const selectHasHelplyCopilotAccess = state => {
  return !!(selectHelplyAccountId(state) && selectHasHelplyCopilotAddon(state))
}
